<template>
  <div class="modal" id="email_usersearch_modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <a id="filter_search_close" class="btn model-c-close-bnt" data-dismiss="modal" aria-hidden="true"><i
            class="fa fa-close fa-2x fa-c-close-icon"></i></a>
          <h4 class="modal-title btn-c-blue"><i class="fa fa-search fa-lg btn-c-blue"></i> Filter Search</h4>
        </div>
        <form name="email_search_user" id="email_search_user" method="post" action="">
          <div class="modal-body">
            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue"><i class="fa fa-filter blue"></i>Main Filters</div>
                <div class="tools">
                  <a href="javascript:void(0);" class="collapse" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body">
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control" name="favorite_filter" id="favorite_filter">
                      <option value="" disabled selected>Favorite Filters</option>
                      <option value="1">filter_zozP</option>
                      <option value="2">asdasdasdsad</option>
                      <option value="3">filter_WYsh</option>
                      <option value="4">Arab Country Filter</option>
                      <option value="5">filter_LeLh</option>
                      <option value="6">filter_OfRs</option>
                      <option value="7">filter_PFQ1</option>
                      <option value="8">filter_m1DP</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <input type="hidden" name="select_user_type" id="select_user_type2" value="">
                    <span class="caption-subject font-blue-sharp">Current User Type</span>
                    <br>
                    <select class="form-control" name="current_user_type[]" id="current_user_type2"
                            placeholder="Current User Type" multiple>
                      <option data-id="12" value=4>B1G1 Member</option>
                      <option data-id="12" value=5>B1G1 Partner</option>
                      <option data-id="12" value=6>Premium Partnership</option>
                      <option data-id="12" value=7>Business for Good Partnership</option>
                      <option data-id="12" value=8>Trial Partner</option>
                      <option data-id="11" value="3">All Businesses</option>
                      <option value="" disabled>---------------------</option>
                      <option data-id="12" value=1>Personal User</option>
                      <option data-id="12" value=2>Personal User</option>
                      <option data-id="12" value=10>Premium Personal User</option>
                      <option data-id="11" value="1">All Individuals</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Previous User Type</span>
                    <br>
                    <select class="form-control" name="previous_user_type[]" id="previous_user_type2"
                            placeholder="Previous User Type" multiple>
                      <option value="">Business For Good</option>
                      <option value="1">B1G1 Member</option>
                      <option value="3">B1G1 partner</option>
                      <option value="5">Lifetime partner</option>
                      <option value="">All Businesses</option>
                      <option value="" disabled>---------------------</option>
                      <option value="">Employee Member</option>
                      <option value="">Personal User</option>
                      <option value="3">B1G1 partner</option>
                      <option value="">Premium Personal</option>
                      <option value="">All Individuals</option>

                    </select>
                  </div>
                </div>
                <div class="row search-c-filter">
                  <div class="col-sm-4">
                    <input type="text" value="" placeholder="Key Word (Name, UID, Email)" id="keyword" name="keyword"
                           class="form-control valid  margin-c2-bottom" aria-required="true"
                           aria-describedby="userpersonalfirstname-error userpersonalfirstname-error"
                           aria-invalid="false">

                    <select class="form-control margin-c2-bottom" name="reg_type" id="reg_type">
                      <option selected="" value="" disabled>Registration Type (Joining Method)</option>
                      <option value="0">Online (Organic)</option>
                      <option value="1">Online (Referral)</option>
                      <option value="2">Event</option>
                      <option value="3">Other</option>
                    </select>

                    <select class="form-control margin-c2-bottom" name="refered_type" id="refered_type">
                      <option selected="" value="" disabled>Reffered by (Company Name)</option>
                      <option value=" ">Type 1</option>
                    </select>
                  </div>

                  <div class="col-sm-4  blue-stripe text-center">
                    <span class="caption-subject font-blue-sharp">Joining date (Range)</span>
                    <br>
                    <div class="input-group input-medium date " style="margin-bottom: 2px;"
                         data-date-format="yyyy-mm-dd" data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker" id="joining_date_from"
                             name="joining_date_from" placeholder="From mm/dd/year" value="">
                      <span class="input-group-btn ">
                                                    <button class="btn default" id="startdateexpiry" type="button"><i
                                                      class="fa fa-calendar"></i></button>
                                               </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="yyyy-mm-dd"
                         data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22"
                             id="joining_date_to" name="joining_date_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                             <button class="btn default" type="button"><i
                                               class="fa fa-calendar"></i></button>
                                        </span>
                    </div>
                  </div>

                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Upgrade/downgrade Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="dd-mm-yyyy" data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker" id="upgrade_from"
                             name="upgrade_from" value="" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                            <button class="btn default" type="button"><i
                                              class="fa fa-calendar"></i></button>
                                        </span>
                    </div>

                    <div class="input-group input-medium date " data-date-format="dd-mm-yyyy"
                         data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker" id="upgrade_to"
                             name="upgrade_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                             <button class="btn default" type="button"><i
                                               class="fa fa-calendar"></i></button>
                                        </span>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control" name="user_status" id="user_status">
                      <option value="" selected>User Status (All)</option>
                      <option value="0">Live</option>
                      <option value="1">Blocked</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Joining date (custom)</span>
                    <br>
                    <select class="form-control" name="joining_custom" id="joining_custom">
                      <option selected="" value="" disabled>Select a custom rage</option>
                      <option value="l1 month">less than 1 month ago</option>
                      <option value="l3 month">less than 3 month ago</option>
                      <option value="l6 month">less than 6 month ago</option>
                      <option value="l1 year">less than 1 year ago</option>
                      <option value="l2 year">less than 2 year ago</option>
                      <option value="l3 year">less than 3 year ago</option>
                      <option value="" disabled>--------------------</option>
                      <option value="m1 month">more than 1 month ago</option>
                      <option value="m3 month">more than 3 month ago</option>
                      <option value="m6 month">more than 6 month ago</option>
                      <option value="m1 year">more than 1 year ago</option>
                      <option value="m1 year">more than 2 year ago</option>
                      <option value="m1 year">more than 3 year ago</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Upgrade/downgrade date (custom)</span>
                    <br>
                    <select class="form-control" name="joining_down_custom" id="joining_down_custom">
                      <option selected="" value="" disabled>Select a custom rage</option>
                      <option value="l1 month">less than 1 month ago</option>
                      <option value="l3 month">less than 3 month ago</option>
                      <option value="l6 month">less than 6 month ago</option>
                      <option value="l1 year">less than 1 year ago</option>
                      <option value="l2 year">less than 2 year ago</option>
                      <option value="l3 year">less than 3 year ago</option>
                      <option value="" disabled>--------------------</option>
                      <option value="m1 month">more than 1 month ago</option>
                      <option value="m3 month">more than 3 month ago</option>
                      <option value="m6 month">more than 6 month ago</option>
                      <option value="m1 year">more than 1 year ago</option>
                      <option value="m1 year">more than 2 year ago</option>
                      <option value="m1 year">more than 3 year ago</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control input-medium" name="user_country[]" id="user_country2"
                            placeholder="User Country" multiple>
                    </select>
                  </div>
                  <div class="col-sm-4">

                  </div>
                  <div class="col-sm-4">
                  </div>
                </div>

              </div>
            </div>

            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue">
                  <i class="fa fa-suitcase"></i>Business Account Filters
                </div>
                <div class="tools">
                  <a href="javascript:void(0);" class="expand" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body" style="display: none;">
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="bus_name" id="bus_name">
                      <option selected="" value="" disabled>Business Name (Personal Name)</option>
                    </select>
                    <select class="form-control margin-c2-bottom" name="bus_acc_status" id="bus_acc_status">
                      <option selected="" value="" disabled>Business Account Status</option>
                      <option value="">Active</option>
                      <option value="">Dormant</option>
                      <option value="">Downgraded</option>
                      <option value="">Blocked</option>
                      <option value="">Upgraded</option>
                    </select>
                    <select class="form-control" name="bus_package" id="bus_package">
                      <option selected="" value="" disabled>Membership Package</option>
                      <option value="1">Tiny</option>
                      <option value="2">Small</option>
                      <option value="3">SME</option>
                      <option value="4">SME PLUS</option>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Registration Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="yyyy-mm-dd" data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22"
                             id="reg_date_from" name="reg_date_from" value="" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                        <button class="btn default" type="button"><i
                                          class="fa fa-calendar"></i></button>
                                     </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="yyyy-mm-dd"
                         data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22" id="reg_date_to"
                             name="reg_date_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                        <button class="btn default" type="button"><i
                                          class="fa fa-calendar"></i></button>
                                         </span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="bus_country[]" id="bus_country2"
                            placeholder="Business Country" multiple>
                    </select>
                    <input type="text" class="form-control margin-c2-bottom" id="bus_city" name="bus_city"
                           placeholder="Business City" value="">
                    <select class="form-control margin-c2-bottom" name="bus_cate" id="bus_cate">
                      <option selected="" value="" disabled>Business Main Category</option>
                      <option value="">B-to-B</option>
                      <option value="">B-to-C</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Joining Date (Custom)</span>
                    <br>
                    <select class="form-control" name="bus_cus_date" id="bus_cus_date">
                      <option selected="" value="" disabled>Select a custom rage</option>
                      <option value="Type 1">Type 1</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp">Industry</span>
                    <br>
                    <select class="form-control input-medium" name="bus_indus[]" id="bus_indus2"
                            placeholder="Industry" multiple>
                    </select>
                  </div>
                </div>

              </div>
            </div>
            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue">
                  <i class="fa fa-money"></i>Contribution Status Filters
                </div>
                <div class="tools">
                  <a href="javascript:void(0);" class="expand" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body" style="display: none;">
                <div class="row">
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="contri_giving_type" id="contri_giving_type"
                            placeholder="Consider giving type">
                      <option value="" disabled selected>Consider Giving Type</option>
                      <option value="0">Consider business giving only</option>
                      <option value="1">Consider personal giving only</option>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe margin-c2-bottom">
                    <span class="caption-subject font-blue-sharp">Last Giving Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="dd-mm-yyyy" data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22"
                             id="lastgiving_from" name="lastgiving_from" value="" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                        <button class="btn default" type="button"><i
                                          class="fa fa-calendar"></i></button>
                                        </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="dd-mm-yyyy"
                         data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker " id="lastgiving_to"
                             name="lastgiving_to" value="" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                     <button class="btn default" type="button"><i class="fa fa-calendar"></i></button>
                                   </span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp"># Of Giving (Range)</span>
                    <br>
                    <input type="text" class="form-control margin-c2-bottom" id="noof_giving_more" value=""
                           name="noof_giving_more" placeholder="Gave more than times">
                    <input type="text" class="form-control margin-c2-bottom" id="noof_giving_less" value=""
                           name="noof_giving_less" placeholder="Gave less than times">
                  </div>
                </div>
                <br>
                <div class="row">

                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" id="con_custom_range" name="con_custom_range">
                      <option selected="" disabled>Select a custom range</option>
                      <option value="Type 1">Type 1</option>
                    </select>
                  </div>

                  <div class="col-sm-4 blue-stripe margin-c2-bottom">
                    <span class="caption-subject font-blue-sharp">Giving Impacts</span>
                    <br>
                    <input type="text" class="form-control margin-c2-bottom" id="con_giving_impact_more"
                           name="con_giving_impact_more" value="" placeholder="Creadited More Than (DGI)">
                    <input type="text" class="form-control margin-c2-bottom" id="con_giving_impact_less"
                           name="con_giving_impact_less" value="" placeholder="Creadited Less Than (DGI)">
                  </div>
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Giving Amout ($)</span>
                    <br>
                    <input type="text" class="form-control margin-c2-bottom" id="giving_amount_more"
                           name="giving_amount_more" value="" placeholder="Gave More Than (USD)">
                    <input type="text" class="form-control margin-c2-bottom" id="giving_amount_less"
                           name="giving_amount_less" value="" placeholder="Gave Less Than (USD)">

                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">

                  </div>
                  <div class="col-sm-4  blue-stripe">
                    <input type="text" class="form-control margin-c2-bottom" id="con_lgi_more" name="con_lgi_more"
                           value="" placeholder="Creadited More Than  (LGI)">
                    <input type="text" class="form-control margin-c2-bottom" id="con_lgi_less" name="con_lgi_less"
                           value="" placeholder="creadited Less Than (LGI)">
                  </div>
                  <div class="col-sm-4">
                  </div>

                </div>
              </div>
            </div>
            <div class="portlet">
              <div class="portlet-title">
                <div class="caption btn-c-blue">
                  <i class="fa fa-tag"></i>Tags & Connection Filters
                </div>
                <div class="tools">
                  <a href="javascript:void(0);" class="expand" data-original-title="" title="">
                  </a>
                </div>
              </div>
              <div class="portlet-body" style="display: none;">
                <div class="row margin-c2-bottom">
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">INCLUDE</span>
                    <select class="form-control input-medium margin-c2-bottom" name="include_tag[]" id="include_tag2"
                            multiple>
                    </select>
                    <span class="caption-subject font-blue-sharp">EXCLUDE</span>
                    <select class="form-control margin-c2-bottom input-medium" name="exclude_tag[]" id="exclude_tag2"
                            multiple>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">INCLUDE</span>
                    <select class="form-control margin-c2-bottom" name="include_milestone" id="include_milestone">
                      <option selected="" value="" disabled>Connection Milestone (s)</option>
                      <option value="Type 1">Type 1</option>
                    </select>
                    <span class="caption-subject font-blue-sharp">EXCLUDE</span>
                    <select class="form-control margin-c2-bottom" name="exclude_milestone" id="exclude_milestone">
                      <option selected="" value="" disabled>Connection Milestone (s)</option>
                      <option value="Type 1">Type 1</option>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe margin-c2-bottom">
                    Invited More Than x Users
                    <input type="text" class="form-control margin-c2-bottom" id="invite_more_user"
                           name="invite_more_user" value="" placeholder="Number Of Users Invited"> Invited Less Than x
                    Users
                    <input type="text" class="form-control margin-c2-bottom" id="invite_less_user"
                           name="invite_less_user" value="" placeholder="Number Of Users Invited">
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4 blue-stripe">
                    <span class="caption-subject font-blue-sharp">Last Message Opened Date (Range)</span>
                    <br>
                    <div style="margin-bottom: 2px;" class="input-group input-medium date "
                         data-date-format="dd-mm-yyyy" data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22" id="lastmsg_from"
                             name="lastmsg_from" placeholder="From mm/dd/year">
                      <span class="input-group-btn ">
                                    <button class="btn default" type="button"><i
                                      class="fa fa-calendar"></i></button>
                                    </span>
                    </div>
                    <div class="input-group input-medium date " data-date-format="dd-mm-yyyy"
                         data-date-start-date="+0d">
                      <input type="text" class="form-control date-picker date-c-picker mycalender22" id="lastmsg_to"
                             name="lastmsg_to" placeholder="To mm/dd/year">
                      <span class="input-group-btn ">
                                    <button class="btn default" type="button"><i
                                      class="fa fa-calendar"></i></button>
                                    </span>
                    </div>

                  </div>
                  <div class="col-sm-4">
                    <select class="form-control margin-c2-bottom" name="mail_open_rate" id="mail_open_rate">
                      <option selected="" value="" disabled>Mail Open Rate</option>
                      <option value="0">0%</option>
                      <option value="1">0% - 10%</option>
                      <option value="2">10.01% - 25%</option>
                      <option value="3">25.01% - 50%</option>
                      <option value="4">50.01% - 75%</option>
                      <option value="5">75.01%</option>
                    </select>
                    <br>
                    <select class="form-control margin-c2-bottom" name="profile_rate" id="profile_rate">
                      <option selected="" value="" disabled>Profile Status</option>
                      <option value="0">Not Completed</option>
                      <option value="1">Completed</option>
                    </select>
                  </div>
                  <div class="col-sm-4 blue-stripe">
                                        <span> Invited More Than x Employees
                                <input type="text" class="form-control " id="emp_more" name="emp_more" value=""
                                       placeholder="Number Of Employees Invited"></span>
                    <br>Invited Less Than x Employees
                    <input type="text" class="form-control " id="emp_less" name="emp_less" value=""
                           placeholder="Number Of Employees Invited">
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <span class="caption-subject font-blue-sharp"> Last Message Opened Rate (Custom)</span>
                    <br>
                    <select class="form-control margin-c2-bottom" name="msg_open_last_custom"
                            id="msg_open_last_custom">
                      <option selected="" value="" disabled>Select a custom range</option>
                      <option value="0">0%</option>
                      <option value="1">0% - 10%</option>
                      <option value="2">10.01% - 25%</option>
                      <option value="3">25.01% - 50%</option>
                      <option value="4">50.01% - 75%</option>
                      <option value="5">75.01%</option>
                    </select>
                  </div>
                  <div class="col-sm-4">

                  </div>
                  <div class="col-sm-4">
                    Invited More Than x-Businesses
                    <input type="text" class="form-control margin-c2-bottom" id="invited_more" name="invited_more"
                           value="" placeholder="Number Of Businesses Invited"> Invited Less Than x-Businesses
                    <input type="text" class="form-control margin-c2-bottom" id="invited_less" name="invited_less"
                           value="" placeholder="Number Of Businesses Invited">
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer" style="text-align: center !important;">
            <button type="submit" class="btn orange btn-c-orange" id="useremail_search_btn">Search</button>
            <button type="reset" class="btn default" id="user_reset_btn"> Reset</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin'
}
</script>



// WEBPACK FOOTER //
// src/components/admin/SearchEmailDialog.vue